jQuery(function($){
  
  var header = $('header').height();
  $('#site>.rte, #site>#slider, #site>.social, #site>.collection-hero, #site>#do-good-program-page').css('margin-top', header)
  $('#mobile-menu').css('top', header)
  
  window.addEventListener('resize', function(event){
    var header = $('header').height();
  	$('#site>.rte, #site>#slider, #site>.social, #site>.collection-hero, #site>#do-good-program-page').css('margin-top', header)
    $('#mobile-menu').css('top', header)
  });

$('html').removeClass('no-js');
$('input').blur();

/* Form validation JS */
/*==========================*/
$('input.error, textarea.error').focus(function() {
	$(this).removeClass('error');
});

$('form :submit').click(function() {
	$(this).parents('form').find('input.hint, textarea.hint').each(function() {
		$(this).val('').removeClass('hint');
	});
	return true;
});


/* Search form JS */
/*==========================*/
$('#main-nav .search-icon').click(function(e) {
	e.preventDefault();

	var input = $(this).parents('form').find('input.search-field');

	if (input.is(':visible')) return;

	input.animate({ width: 'toggle' }, 300, function() {
		input.focus();
	});
})

$('#main-nav .search-field').blur(function() {
	$(this).animate({ width: 'toggle' }, 300);
});

/* Newsletter form JS */
/*==========================*/
/*$('#site-footer .contact-form').submit(function(e) {
	var form = $(this),
		url = form.attr('action'),
		data = form.serialize();

	$.post(url, data, function(response) {
		var html = $(response),
			error = $('#newsletter-error', html).eq(0),
			success = $('#newsletter-success', html).eq(0);

		if (success.length) {
			$('#newsletter-message').html(success);
		} else {
			$('#newsletter-message').html(error);
		}
	});

	$('#newsletter-message').html('');

	e.preventDefault();
});*/


/* Location search form JS */
/*==========================*/
$(function() {
	var params = window.location.search,
		map = $('#storemapper');

	if (params && map.length) {
		params = params.replace('\?', '').split('&');
		for (var i = 0; i < params.length; i++) {
			var pair = params[i].split('='),
				key = pair[0],
				value = pair[1];

			if (key == 'location' && value != '') {
				setTimeout(function() {
					$('#storemapper-zip').val(value);
					$('#storemapper-go').trigger('click');
				}, 3000);
			}
		}

	}
});

/* Homepage slider JS */
/*==========================*/
$(document).ready(function(){	
	var oneSlider = ($('.bx-slider').children().length < 2);
	var slider = $('.bx-slider').bxSlider({  auto: (!oneSlider), pager: (!oneSlider) });
	$(window).on('resize',function(){	
		if($('.bx-slider').children().length > 0) slider.reloadSlider();
	});
});




/* Responsive iFrame JS */
/*==========================*/
$('.rte iframe, .media-grid iframe').each(function() {
	var iframe = $(this),
		container = iframe.parent(),
		w = container.width();

	iframe
		.data('aspect-ratio', this.height / this.width)
		.removeAttr('height').removeAttr('width')
		.width(w).height(w * iframe.data('aspect-ratio'));
});

$(window).resize(function() {
	var iframes = $('.rte iframe, .media-grid iframe');

	iframes.each(function() {
		var iframe = $(this),
			container = iframe.parent(),
			w = container.width();

		iframe.width(w).height(w * iframe.data('aspect-ratio'));
	});
}).resize();


/* Collection heading JS */
/*==========================*/
$('#collection-rte').each(function() {
	var content = $(this),
		media = content.find('img, iframe').not('#LifestyleImages img').detach(),
		description = content.html();

	//$('#collection-description').append(description);
	//$('#collection-media').append(media);
	//content.remove();


	// Remove width and height from iframe
	$('#collection-media iframe').each(function() {
		var iframe = $(this);

		 iframe.data('aspect-ratio', this.height / this.width).removeAttr('height').removeAttr('width');
	});
});

$(window).resize(function() {
	var container = $('#collection-media'),
		iframes = $('iframe', container),
		w = container.width();

	iframes.each(function() {
		var iframe = $(this);

		iframe.width(w).height(w * iframe.data('aspect-ratio'));
	});
}).resize();



/* Variant list JS */
/*==========================*/
$('.variant-list').on('change', function(e) {
	var select = $(this),
		option = select.find('option:selected'),
		title = option.attr('data-variant-title'),
		available = option.attr('data-available');

	var container = select.closest('.product-wrapper'),
		prices = $('.variant-prices li', container),
		inventories = $('.variant-titles li', container);

	var form = select.closest('form'),
		button = $('.add-to-cart', form);

	prices.hide();
	inventories.hide();
	$('#variant-name').html(title);
	$('.variant-prices [data-variant-id="' + option.val() + '"]').show();
	$('.variant-titles [data-variant-id="' + option.val() + '"]').show();

	// Add sale tag to variant image
	setTimeout(function() {
		$('.multiple-options .product-images li', container).removeClass('sale');
		if (option.data('price') < option.data('compare-at-price'))
		{
			$('.product-images li:visible', container).addClass('sale');
		}
	}, 50);


	if (select.hasClass('coming-soon')) {
		button.addClass('disabled').val('COMING SOON');
	}
  else if (select.is(':disabled')) {
		button.addClass('disabled').val('UNAVAILABLE');
	}
	else if (available == 'false') {
		button.addClass('disabled').val('SOLD OUT');
	}
	else {
		button.removeClass('disabled').val('ADD TO CART');
	}
}).trigger('change');

/* Collection grid JS */
/*==========================*/
$('.grid-item .product-images').swipe({
	swipeLeft: nextVariant,
	swipeRight: prevVariant,
	allowPageScroll: "vertical",
	excludedElements: ".noSwipe",
	threshold: 50
});

function nextVariant(event, phase, direction, distance) {
	var el = $(this),
			item = el.closest('.grid-item'),
			picker = $('.variant-picker', item),
			anchors = $('a', picker);

	var selected = anchors.filter('.active'),
			index = anchors.index(selected);

	var next = (index >= anchors.length) ? anchors.length : index + 1;

	anchors.eq(next).trigger('mouseenter');
}

function prevVariant(event, phase, direction, distance) {
	var el = $(this),
			item = el.closest('.grid-item'),
			picker = $('.variant-picker', item),
			anchors = $('a', picker);

	var selected = anchors.filter('.active'),
			index = anchors.index(selected);

	var next = (index > 0) ? index - 1 : 0;

	anchors.eq(next).trigger('mouseenter');
}

$('.variant-picker a').hover(function() {
	var anchor = $(this);

	var container = anchor.closest('.product-wrapper'),
		anchors = $('.variant-picker a', container),
		images = $('.product-images li', container),
		names = $('.variant-titles li', container),
		prices = $('.variant-prices li' ,container),
		select = $('.variant-list', container);

	var id = anchor.attr('data-variant-id');

	images.hide();
	names.hide();
	prices.hide();
	anchors.removeClass('active');

	anchor.addClass('active');
	$('[data-variant-id="' + id + '"]').show();

	select.val(id).trigger('change');

})
.click(function(e) {
	e.preventDefault();
});

$('.variant-picker').each(function() {
	var picker = $(this),
		anchors = $('a', picker),
		available = false;

	anchors.each(function() {
		var variant = $(this);
		if (variant.data('available')) {
			variant.trigger('mouseenter');
			available = true;
			return false;
		}
	});

	if (!available) anchors.first().trigger('mouseenter');
});

/* Product Image Zoom JS */
/*==========================*/
$('.main-photo').zoom({ callback: function() {
	var src = $('#product-photo').attr('src').replace('_grande.jpg', '_1024x1024.jpg');

	$('.zoomImg').attr('src', src);
} });


/* Product Thumbnails JS */
/*==========================*/
$('#product-thumbnails a').on('click', function(e, source) {
	var anchor = $(this),
		anchors = anchor.closest('ul').find('a'),
		image = $('#product-photo'),
		zoom = $('.main-photo .zoomImg');

	anchors.removeClass('active');
	anchor.addClass('active');

	var options = anchor.data('option-size');

	var option1 = anchor.data('option1'),
			option2 = anchor.data('option2'),
			option3 = anchor.data('option3');

	if (option1) { $('select[data-option="option1"]').val(option1).trigger('change'); }
	if (option2) { $('select[data-option="option2"]').val(option2).trigger('change'); }
	if (option3) { $('select[data-option="option3"]').val(option3).trigger('change'); }

	e.preventDefault();
});


/* Product Add to Cart Form JS */
/*==========================*/
$('form.product-form').on('submit', function(e) {
	var button = $('.add-to-cart', this),
		select = $('.variant-list', this),
		option = select.find('option:selected');

	if (button.hasClass('disabled')) return false;

	var valid = (select.val() == '') ? false : true,
		container = select.attr('data-container'),
		options = $('.option-group', container);

	options.each(function() {
		var group = $(this),
			selected = $('.option-list a.active', group);

		if (! selected.length) {
			$('.error-message', group).fadeIn('fast');
			valid = false;
		}
	});

	if (! valid) return false;
});

$('.qty-input').on('change', function() {
	$('#checkout').attr('name', 'update').trigger('click');
});


/* Mobile Menu Navigation JS */
/*==========================*/
$('#mobile-menu-button, #mobile-menu-close').on('click', function(e) {
	var menu = $('#mobile-menu'),
		site = $('#site'),
		close = $('#mobile-menu-close');

	$( 'html' ).removeClass( 'js--right' );
	$('#mobile-menu ul').removeClass('child-open');
	$('#mobile-menu ul li').removeClass('sub-open');

	if (menu.is(':visible')) {
		menu.animate({ height: '0' }, 'fast', function() { menu.removeClass('menu-open'); $('body').removeClass('mobile-open'); });
		$( 'html' ).removeClass( 'js--right' );
		/*site.animate({ left: '0%' }, 'fast', function() {
			site.removeClass('menu-open');
			$('html').removeClass('menu-open');
		});*/
	} else {
		//$('html').addClass('menu-open');
		$( 'html' ).addClass( 'js--right' );
        var height = $('body').height() - $('header').height();
        
		menu.addClass('menu-open').animate({ height: height }, 'fast');
      	$('body').addClass('mobile-open');
		//site.addClass('menu-open').animate({ left: '80%' }, 'fast');
	}

	e.preventDefault();
});

$('#mobile-menu ul li .open-right').on('click',function(){

	$(this).closest('ul').addClass('child-open');
	$(this).closest('li').addClass('sub-open');
	
});

$('#mobile-menu ul .close-right').on('click',function(){

	$('#mobile-menu ul').removeClass('child-open');
	$('#mobile-menu ul li').removeClass('sub-open');
});

/* Lookbook JS */
/*==========================*/
$('[data-configid]').each(function() {
	var frame = $(this),
		container = frame.parent(),
		w = container.width();

	frame
		.data('aspect-ratio', frame.height() / frame.width())
		.width(w).height(w * frame.data('aspect-ratio'));
});

$(window).resize(function() {
	var frames = $('[data-configid]');

	frames.each(function() {
		var frame = $(this),
			container = frame.parent(),
			w = container.width();

		frame.width(w).height(w * frame.data('aspect-ratio'));
	});
}).resize();


/* FriendBuy JS */
/*==========================*/
$('a[data-friendbuy-id]').on('click', function(e) {
	var id = $(this).data('friendbuy-id');

	$('.' + id).eq(0).trigger('click');

	e.preventDefault();
});

});
